/**
 * Play/pause hero slideshow videos when Swiper changes slides (document `slider:slide:change`).
 * Single-slide heroes do not initialize Swiper, so we treat one real slide as always active.
 */
(function () {
  function youtubeCommand(iframe, func) {
    try {
      iframe.contentWindow?.postMessage(
        JSON.stringify({ event: 'command', func: func, args: [] }),
        '*'
      );
    } catch (_e) {
      /* ignore */
    }
  }

  function slideIsSwiperActive(slide) {
    return (
      slide.classList.contains('swiper-slide-active') ||
      slide.classList.contains('swiper-slide-duplicate-active')
    );
  }

  function syncVideosInSwiper(swiperEl) {
    if (!swiperEl) return;

    var realSlides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
    var heroWithoutSwiper = realSlides.length <= 1;

    swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
      var active;
      if (heroWithoutSwiper) {
        active = !slide.classList.contains('swiper-slide-duplicate');
      } else {
        active = slideIsSwiperActive(slide);
      }

      var videoWrap = slide.querySelector('[data-slideshow-slide-media="video"]');
      var autoplayOn = !videoWrap || videoWrap.getAttribute('data-slideshow-autoplay') !== 'false';

      slide.querySelectorAll('video.slideshow-slide-video').forEach(function (videoEl) {
        if (active && autoplayOn) {
          if (videoWrap && videoWrap.getAttribute('data-slideshow-muted') === 'true') {
            videoEl.muted = true;
          }
          var p = videoEl.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else if (!videoEl.paused) {
          videoEl.pause();
        }
      });

      slide.querySelectorAll('.slideshow-slide__external-video iframe').forEach(function (frame) {
        var src = frame.src || '';
        if (!active || !autoplayOn) {
          if (src.indexOf('youtube.com') !== -1) youtubeCommand(frame, 'pauseVideo');
          else if (src.indexOf('vimeo.com') !== -1) frame.contentWindow?.postMessage('{"method":"pause"}', '*');
          return;
        }
        if (src.indexOf('youtube.com') !== -1) youtubeCommand(frame, 'playVideo');
        else if (src.indexOf('vimeo.com') !== -1) frame.contentWindow?.postMessage('{"method":"play"}', '*');
      });
    });
  }

  function bindSwiper(swiperEl) {
    if (!swiperEl || swiperEl.dataset.slideshowVideoBound === 'true') return;
    swiperEl.dataset.slideshowVideoBound = 'true';

    var run = function () {
      syncVideosInSwiper(swiperEl);
    };

    document.addEventListener('slider:slide:change', run);
    window.addEventListener('load', run);
    setTimeout(run, 0);
    setTimeout(run, 200);
    setTimeout(run, 900);
    setTimeout(run, 2000);
  }

  function initSlideshowVideos(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll('[data-wetheme-section-type="image--slideshow"] .swiper').forEach(bindSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSlideshowVideos();
    });
  } else {
    initSlideshowVideos();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-wetheme-section-type="image--slideshow"]')) {
      initSlideshowVideos(e.target);
    }
  });
})();
